export interface ChallengeType {
    id: string;
    name: string;
    componentName: string;
}

export const challengeTypes: ChallengeType[] = [
    {
        id: 'PERSONALITY_TRAITS',
        name: 'La personalidad que habitará',
        componentName: 'PersonalityTraits'
    },
    {
        id: 'VIRTUAL_SPACES',
        name: 'Traslados virtuales a espacios',
        componentName: 'VirtualSpaces'
    },
    {
        id: 'VIRTUAL_SPACES_SCORING',
        name: 'Puntuación de espacios virtuales',
        componentName: 'VirtualSpacesScoring'
    },
    {
        id: 'LANDSCAPE_AND_TEXTURES',
        name: 'Paisajes y texturas',
        componentName: 'LandscapeAndTextures'
    },
    {
        id: 'HAND_DOESNT_LIE',
        name: 'La mano no miente',
        componentName: 'HandDoesntLie'
    },
    {
        id: 'SPATIAL_EXPERIENCE',
        name: 'Experiencia espacial',
        componentName: 'SpatialExperience'
    },
    {
        id: 'SPATIAL_EXPERIENCE_RESSO_CONFIG',
        name: 'Configuración Resso Experiencia Espacial',
        componentName: 'SpatialExperienceRessoConfig'
    },
    {
        id: 'SPATIAL_EXPERIENCE_RESSO',
        name: 'Experiencia Espacial Resso',
        componentName: 'SpatialExperienceResso'
    }
];

export const getChallengeTypeById = (id: string): ChallengeType | undefined => {
    return challengeTypes.find(type => type.id === id);
};